import { atom } from 'jotai';

export const isAwayAtom = atom<boolean>(false);
